// extracted by mini-css-extract-plugin
export default {"root":"styles_root__LDF9i","detail":"styles_detail__rpM0N","text":"styles_text__ba9ar"};